<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
<div>
  {{$t('news.template.party.created.p1')}}
  <router-link :to="{name: 'OrganizationView', params: {id: news.textParams[0]}}"
  >{{news.textParams[1]}}</router-link>
  {{$t('news.template.party.created.p2')}}
  {{news.textParams[1]}}
  {{$t('news.template.party.created.p3')}}
  <router-link :to="{name: 'forum', params: {id: news.textParams[2]}}">
    {{news.textParams[3]}}
  </router-link>.
</div>
</template>
